export default {
      id: "dashboard-usage",
      viewBox: "0 0 132 87",
      url: __webpack_public_path__ + "icons-sprite.396b316.svg#dashboard-usage",
      toString: function () {
        return this.url;
      }
    }